import CryptoJS from 'crypto-js';

const ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY;

export const encryptResponse = (response) => {

    const iv = CryptoJS.lib.WordArray.random(16); // 16 bytes IV for AES
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(response), CryptoJS.enc.Utf8.parse(ENCRYPTION_KEY), { iv: iv }).toString();
    // Return both the encrypted data and IV (IV must be sent separately to the client)
    return {
        encrypted: encrypted,
        iv: iv.toString(CryptoJS.enc.Base64) // Send IV as Base64 string
    };

};

export const decryptResponse = (response, ivBase64) => {
    try {
        const iv = CryptoJS.enc.Base64.parse(ivBase64); // Convert Base64 IV back to WordArray
        const decrypted = CryptoJS.AES.decrypt(response, CryptoJS.enc.Utf8.parse(ENCRYPTION_KEY), { iv: iv }).toString(CryptoJS.enc.Utf8);
        return JSON.parse(decrypted);
    } catch (error) {
        console.error("Decryption failed:", error);
        return null;
    }

};


